import {useAufgabenHandling} from "../../hooks/aufgaben/useAufgabenHandling";
import Layout from "../../components/Layout";
import {capitalize, Paper, Tab, Tabs} from "@mui/material";
import {Outlet, useParams} from "react-router";
import {aufgabenStyles} from "../../styles/aufgaben/aufgaben.styles";
import {SyntheticEvent} from "react";
import {useUserMandant} from "../../hooks/useUserMandant";
import {permissions} from "../../permissions";

export default function PageAufgabenTabs() {
    const {translation, currentTab, handleTabChange} = useAufgabenHandling();
    const { checkHasOneOfPermissions, isMandantAnrufer } = useUserMandant();
    const {aufgabeId} = useParams();

    return (
        <Layout
            title={isMandantAnrufer ? capitalize(translation("contacts")) : capitalize(translation("task-edit"))}
            back="/aufgaben"
        >
            <Tabs value={currentTab} onChange={(event: SyntheticEvent, newValue) => handleTabChange(
                event,
                newValue,
                aufgabeId
            )}>
                {!isMandantAnrufer && (
                    <Tab label={capitalize(translation("edit"))} value="" disabled={!checkHasOneOfPermissions([
                        permissions.aufgaben.edit,
                        permissions.aufgaben.own_edit,
                        permissions.aufgaben.show,
                        permissions.aufgaben.own_show,
                    ])}/>
                )}
                {!isMandantAnrufer && (
                    <Tab label={capitalize(translation("prompt-versions-tab"))} value="versions" disabled={!checkHasOneOfPermissions([
                        permissions.aufgaben.show,
                        permissions.aufgaben.own_show,
                    ])}/>
                )}
                {!isMandantAnrufer && (
                    <Tab label={capitalize(translation("sub-tasks"))} value="unteraufgaben" disabled={!checkHasOneOfPermissions([
                        permissions.unteraufgaben.list,
                        permissions.unteraufgaben.own_list,
                        permissions.unteraufgaben.edit,
                        permissions.unteraufgaben.own_edit,
                        permissions.unteraufgaben.show,
                        permissions.unteraufgaben.own_show,
                        permissions.unteraufgaben.create,
                        permissions.unteraufgaben.own_create,
                    ])}/>
                )}
                {!isMandantAnrufer && (
                    <Tab label={capitalize(translation("scheduler-tab"))} value="scheduler" disabled={!checkHasOneOfPermissions([
                        permissions.schedulers.list,
                        permissions.schedulers.own_list,
                        permissions.schedulers.show,
                        permissions.schedulers.own_show,
                    ])}/>
                )}
                <Tab label={capitalize(translation("contacts"))} value="kontakte" disabled={!checkHasOneOfPermissions([
                    permissions.kontakte.list,
                    permissions.kontakte.own_list,
                    permissions.kontakte.show,
                    permissions.kontakte.own_show,
                ])}/>
            </Tabs>
            <Paper id={'page-update-aufgabe-paper'}
                   elevation={1}
                   sx={aufgabenStyles.pageUpdateAufgabe.paper}
            >
                <Outlet/>
            </Paper>
        </Layout>
    );
}